export const sx = {
    root: {
        '.lightTheme &': {
            backgroundColor: "rgb(255, 255, 255)",
            color: "rgba(0, 0, 0, 0.87)",
        },

        transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        borderRadius: "4px",
        boxShadow:
            "rgba(0, 0, 0, 0.2) 0px 11px 15px -7px, rgba(0, 0, 0, 0.14) 0px 24px 38px 3px, rgba(0, 0, 0, 0.12) 0px 9px 46px 8px",
        margin: {
            lg: '32px'
        },
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)",
        maxWidth: "600px",
        minWidth: {
            xs: "300px",
            lg: '600px'
        },
        padding: 2,
        position: "absolute",
        top: "50%",
        left: "50%",
        minHeight: '300px',
        transform: "translate(-50%,-50%)"
    },
}